module.exports = __webpack_public_path__ + "static/img/europe_1.e681fd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/europe_1.png
// module id = qty0
// module chunks = 2